module.exports = __webpack_public_path__ + "img/widget_photos.656d8b3.png";